import IGlassWallDoor from 'components/interfaces/IGlassWallDoor';
import IWall from 'components/interfaces/IWall';
import { HANDLE_TYPE_1 } from 'components/configurator/types/handleTypes';
import { RIGHT } from 'components/configurator/types/doorHangTypes';

import doorPlacementTypes from '../../../../types/doorPlacementTypes';
import glassWallPartTypes from '../../../../types/glassWallPartTypes';

import { DOOR_GLASS_8 } from '../../../../types/doorGlassTypes';
import { SLIDY_30, SLIDY_36 } from '../../../../types/glazingWallTypes';
import {
  SLIDY_DOOR_30,
  SLIDY_DOOR_36,
  WOODY_BOX,
} from '../../../../types/doorTypes';
import { isWoodyTypeWall } from '../../../../types/glazingWallTypesCheck';

const getDoorType = (wall: IWall): string => {
  if (wall.glazingWallType === SLIDY_30) {
    return SLIDY_DOOR_30;
  }

  if (wall.glazingWallType === SLIDY_36) {
    return SLIDY_DOOR_36;
  }

  if (isWoodyTypeWall(wall)) {
    return WOODY_BOX;
  }

  return SLIDY_DOOR_30;
};

const getDefaultGlassWallDoor = (id = 1, wall: IWall): IGlassWallDoor => ({
  //  aluDoorIn2kOffset: 7,
  areaName: 'door',
  doorDirection: 'inward',
  doorGlassIds: {
    primaryGlassId: '1',
    aboveGlassId: '2',
    secondaryGlassId: '3',
    sideGlassLeftId: '4',
    sideGlassRightId: '5',
  },
  doorGlassNames: {
    primaryGlassName: '',
    aboveGlassName: '',
    secondaryGlassName: '',
    sideGlassLeftName: '',
    sideGlassRightName: '',
  },
  doorGlassType: DOOR_GLASS_8,
  doorHang: RIGHT,
  doorID: 'door',
  doorOpeningWidth: 850,
  doorOpeningHeight: 0,
  doorPlacementType: doorPlacementTypes.middle,
  doorSide: 'inside',
  excludeStopper: false,
  handleHeight: 1100,
  handleType: HANDLE_TYPE_1,
  hasLeftDoorPrimary: false,
  hasLock: false,
  hasLongStopper: true,
  id,
  isFirstDoor: false,
  isLastDoor: false,
  leftSideGlassWidth: 250,
  insertPosition: 1000,
  primaryDoorWidth: 850,
  secondaryCornerPlacement: '-',
  thresholdType: 'aluminium',
  totalAreaLength: 850,
  type: glassWallPartTypes.door,
  typeName: getDoorType(wall),
  woodyDoorPositionOffset: 0,
  woodyLeftExtraWoodyProfile: false,
  woodyLeftExtraAluProfile: false,
  woodyLeftExtraProfileHeight: 25,
  woodyLeftElectricalBox: false,
  woodyRightElectricalBox: false,
  woodyLeftElectricalBoxWidth: 250,
  woodyRightElectricalBoxWidth: 250,
  woodyRightExtraWoodyProfile: false,
  woodyRightExtraAluProfile: false,
  woodyRightExtraProfileHeight: 25,
  woodyThresholdType: 'nothreshold',
  woodyHingeType: 'default',
  woodyTotalPortalWidth: 2000,
  woodyLeftSidePortalWidth: 300,
  woodyDoorLeftGlassDepth: 6,
  woodyDoorRightGlassDepth: 6,
  woodyDoorLeftGrooveDepth: 8,
  woodyDoorRightGrooveDepth: 8,
  woodyDoorFrameDepth: 92,
  // From here they are hardcoded fields not included in the form
  woodyDoorFrameColor: '',
  woodyDoorLeafColor: '',
  hasSolidSlaveDoor: false,
});

export default getDefaultGlassWallDoor;
